var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { OnInit, OnDestroy } from '@angular/core';
import { AttributeFilterService } from 'app/services/attribute-filter.service';
// import { MatDialogRef } from '@angular/material';
import { ToastrService } from 'ngx-toastr';
var FeatAttributeFiltersPopupComponent = /** @class */ (function () {
    function FeatAttributeFiltersPopupComponent(
    // private dialog: MatDialogRef<FeatAttributeFiltersPopupComponent>,
    toastr, attrFilterService) {
        this.toastr = toastr;
        this.attrFilterService = attrFilterService;
        this.attrFilters = [];
        this.attrFilterStatus = 'clean';
        this.maxNumOfFilter = 5;
    }
    // cancel() {
    // 	this.dialog.close();
    // }
    FeatAttributeFiltersPopupComponent.prototype.applyAttrFilter = function () {
        this.attrFilterService.attrFilters.next({
            source: 'popup',
            filters: this.attrFilters
        });
        // this.dialog.close();
    };
    FeatAttributeFiltersPopupComponent.prototype.addEmptyFilter = function () {
        if (this.attrFilters.length >= this.maxNumOfFilter) {
            this.toastr.info('exceed max filter number');
            return;
        }
        this.attrFilters.push({
            filter: null
        });
    };
    FeatAttributeFiltersPopupComponent.prototype.removeFilter = function (idx) {
        if (this.attrFilters.length === 1) {
            return;
        }
        this.attrFilters.splice(idx, 1);
        // this.applyAttrFilter();
        this.triggerFilterChangeWithoutGetData();
    };
    FeatAttributeFiltersPopupComponent.prototype.removeAllAttrFilters = function () {
        this.attrFilterService.clearAttrFilters();
    };
    FeatAttributeFiltersPopupComponent.prototype.onAttrFilterChange = function (event, idx) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.attrFilters[idx].filter = event;
                if (event) {
                    this.updateFilterStatus('dirty');
                }
                else {
                    // User remove a filter manually
                    if (this.attrFilterStatus !== 'clean') {
                        this.updateFilterStatus('dirty');
                    }
                    else { // User remove filters by clicking filter-remove button // filterStatus's been set clean in clearFilter()
                    }
                }
                this.triggerFilterChangeWithoutGetData();
                return [2 /*return*/];
            });
        });
    };
    FeatAttributeFiltersPopupComponent.prototype.triggerFilterChangeWithoutGetData = function () {
        this.attrFilterService.attrFilters.next({
            source: 'popup',
            filters: this.attrFilters,
            skipGetData: true
        });
    };
    FeatAttributeFiltersPopupComponent.prototype.updateFilterStatus = function (status) {
        this.attrFilterStatus = status;
    };
    FeatAttributeFiltersPopupComponent.prototype.ngOnInit = function () {
        var _this = this;
        var isInit = true;
        this.attrFiltersSub = this.attrFilterService.attrFilters.subscribe(function (data) {
            if (isInit || data.source !== 'popup') {
                _this.attrFilters = JSON.parse(JSON.stringify(data.filters));
                if (!_this.attrFilters.length) {
                    _this.addEmptyFilter();
                }
                isInit = false;
            }
        });
        this.filterColumnsSub = this.attrFilterService.attrFilterColumns.subscribe(function (data) {
            _this.attrFilterColumns = data || [];
        });
    };
    FeatAttributeFiltersPopupComponent.prototype.ngOnDestroy = function () {
        this.attrFiltersSub.unsubscribe();
        this.filterColumnsSub.unsubscribe();
    };
    return FeatAttributeFiltersPopupComponent;
}());
export { FeatAttributeFiltersPopupComponent };
